import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'public-improvements';

export function useGetAllPublicImprovements(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetPublicImprovement(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreatePublicImprovement() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdatePublicImprovement({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeletePublicImprovement({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
